import { SxProps } from '@mui/material';
import { lightTheme } from '@foxtons/fdl/theme';

const { palette, spacing, typography } = lightTheme;
const tabStyle = {
  padding: '0.5rem',
  borderRadius: '0.25rem',
  cursor: 'pointer'
};

const styles: Record<string, SxProps> = {
  mainText: {
    color: palette.grey.main,
    marginBottom: spacing(0.5)
  },
  boxPadding: {
    paddingTop: spacing(1),
    height: '100%'
  },
  subText: {
    fontWeight: 700
  },
  tabContainer: {
    '& .MuiTabs-indicator': {
      display: 'none'
    },

    '.MuiTabs-flexContainer': {
      gap: {
        xs: spacing(0.5),
        md: spacing(1)
      },
      paddingTop: spacing(0.5),
      flexWrap: 'wrap',
      display: 'flex',
      flexDirection: 'row'
    },
    height: '100%'
  },
  tabPill: {
    ...tabStyle,
    ...typography.subtitle2,
    background: palette.grey[50],
    color: palette.grey.main,
    opacity: '1',
    textTransform: 'none',
    border: `0.0625rem solid ${palette.secondary[600]}`,
    borderRadius: '0.25rem',
    minHeight: '2rem',
    minWidth: 'auto'
  },
  selectedTabPill: {
    ...tabStyle,
    ...typography.subtitle2,
    backgroundColor: palette.primary.main,
    color: `${palette.primary[50]} !important`,
    opacity: '1',
    textTransform: 'none',
    borderRadius: '0.25rem',
    minHeight: '2rem',
    minWidth: 'auto'
  },
  selectComponent: {
    height: '3rem',
    '& > div': {
      padding: '0.5rem 1rem'
    },
    '& .MuiSelect-select': {
      padding: '0.5rem 1rem'
    },
    '& svg': {
      color: palette.primary.main
    },
    '& .MuiMenuItem-root': {
      position: 'relative',
      '&::after': {
        content: '""',
        position: 'absolute',
        border: `0.01rem solid ${palette.grey['100']}`,
        width: '75%',
        bottom: '0'
      }
    },
    '& fieldset': {
      '&:hover': {
        border: `0.063rem solid ${palette.primary.main}`
      }
    },
    '& option': {
      color: palette.grey.main,
      padding: '0.75rem'
    }
  },

  tabBox: {
    height: '100%'
  },
  loadingBox: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  tabPanel: {
    height: '100%'
  },
  phoneLink: {
    cursor: 'pointer',
    textDecoration: 'underline',
    fontWeight: 600,
    color: palette.primary.main
  },
  tabChildren: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: spacing(1)
  },
  containerBorder: {
    border: `0.0625rem solid ${palette.secondary[600]}`,
    borderRadius: '0.5rem',
    height: 'fit-content',
    padding: spacing(1),
    marginBottom: spacing(1),
    width: '100%'
  },
  inputLabel: {
    color: palette.grey.main,
    marginTop: spacing(1),
    marginBottom: spacing(0.5)
  },
  repaymentRadioContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  repaymentText: {
    fontWeight: 700,
    color: palette.grey.main
  },
  bottomText: {
    color: palette.grey.main,
    display: 'block',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'left',
    marginBottom: spacing(1)
  },
  sectionTitle: { color: palette.grey.main, fontWeight: 600 },
  mortgageTitle: {
    fontWeight: '600',
    color: palette.grey.main,
    marginBottom: spacing(1)
  },
  checkboxesContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing(0.5)
  },
  checkboxContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },
  depositContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  depositPercent: {
    color: palette.primary.main,
    fontWeight: 700,
    paddingTop: '1.5rem'
  },
  slider: {
    paddingTop: '1.5rem',
    color: palette.primary.main,
    '& .MuiSlider-thumb': {
      height: '1.25rem',
      width: '1.25rem',
      backgroundColor: palette.grey[50]
    }
  },
  hyperLink: {
    fontWeight: 400,
    color: palette.primary.main,
    textDecoration: 'underline',
    cursor: 'pointer'
  },
  buttonContainer: {
    marginTop: spacing(1),
    width: '100%',
    gap: 1,
    flexDirection: {
      xs: 'column',
      md: 'row'
    },
    display: 'flex',
    justifyContent: 'space-between'
  },
  closeButton: {
    pb: {
      xs: spacing(1),
      md: spacing(2)
    },
    pt: {
      md: spacing(1)
    },
    width: '100%'
  },
  interestBox: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: spacing(1)
  }
};

export default styles;
